<template>
  <div>
    <div class="ta_c" style="padding:90px 0 90px;">
      <img src="./../../assets/img/img_lvshoucamp_beauty.png" alt="绿瘦训练营">
    </div>
    <div class="paragraph-body">
      <p>绿瘦训练营是中国体重管理行业领先品牌绿瘦旗下的“线下全封闭式减肥训练机构”。通过“运动减脂+均衡饮食”的方式达到健康减肥的效果。训练营依据人体成分分析、4M体能测试及体检数据为客户量身定制运动减脂方案，并由资深教练带队训练，体重管理师搭配运动减脂营养餐，帮助营员减重的同时改善身体健康指标，提高体适能，并培养健康的生活习惯和理念。</p>
      <h3 class="paragraph-title">训练营健身房</h3>
      <p>训练营自建减肥训练场地，配有力量及有氧训练区，综合操厅、瑜伽室、动感单车室、普拉提康复室、私教室等。配备各类型运动器械，功能齐全。</p>
      <div class="paragraph-body-covermap clearfix">
        <img data-v-fae5bece="" src="http://www.lvshouhotel.com/lvshouhotel/img_xuanlianying_lvscamp.png">
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "lvshouTrainCamp",
  data() {
    return {

    }
  },
  components: {
   
  }
};
</script>

<style lang="less" scoped>
.paragraph-body{
  width: 968px;
  .paragraph-title{
    padding-bottom: 16px;
    font-size: 30px;
    color: #333333;
  }
  .paragraph-body-covermap {
    padding-top: 16px;
    .fl:first-child{
      margin-right: 10px;
    }
  }
}
</style>

